export default "__VITE_ASSET__VpgjASj3__"